import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import PreauthorizationRequrestPatientInfo from "./PreauthorizationRequrestPatientInfo";
import DoctorInfoCard from "./DoctorInfoCard";
import ClaimHeaderCard from "./ClaimHeaderCard";
import PreauthorizationInformations from "./PreauthorizationInformations";
import { useForm } from "react-hook-form";
import DiagnosisVitalMedicalDetails from "./DiagnosisVitalMedicalDetails";
import { useSelector } from "react-redux";

import ClaimPaymentTableCard from "./ClaimPaymentTableCard";

const ClaimsViewRequestDetails = ({ activeKey, setActiveKey }) => {
  const { watch, setValue, control, clearErrors, setError } = useForm({
    defaultValues: {},
  });

  const { viewClaimInfo } = useSelector((state) => state.claim);

  // ✅ Show loader until all required data is present

  return (
    <Row>
      <Col xs={12} md={4} xl={2}>
        <Row className="d-flex flex-column rounded border border-primary">
          <PreauthorizationRequrestPatientInfo />
          <DoctorInfoCard />
          <ClaimHeaderCard />
        </Row>
      </Col>
      <Col xs={12} md={8} xl={6} className="mb-3">
        <PreauthorizationInformations
          control={control}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          setError={setError}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
        />
        <ClaimPaymentTableCard data={viewClaimInfo?.pay_details || []} />
      </Col>
      <Col xs={12} md={12} xl={4}>
        <DiagnosisVitalMedicalDetails />
      </Col>
    </Row>
  );
};

export default ClaimsViewRequestDetails;
